import { LOADING } from "../../Actions/Types";
import { VerifyDomainAPI } from "../../Api/DomainApi/VerifyDomainApi";

// service to get domain list only
const VerifyDomainService = async (
    token: string, // access token
    websiteId: string,
    dispatch: Function, // dispatch function to store redux data
    setMessage: Function, // dispatch function to store redux data
    setIsVerified: Function, // dispatch function to store redux data
): Promise<any> => {

    // Set Loading
    dispatch({
        type: LOADING,
        payload: true,
    });

    // API to get domain list    
    VerifyDomainAPI(token, websiteId).then((dataRes) => {
        console.log('dataRes: ', dataRes);
        // check if response is ok
        dispatch({
            type: LOADING,
            payload: false
        });

        if (dataRes) {
            setMessage(dataRes.msg);
            
            if (dataRes.is_verified === 1) {
                setIsVerified(true);
            } else {
                setIsVerified(false);
            }
        }
        
        return dataRes
    });

    return {status:200}
}

export { VerifyDomainService }